import clsx from 'clsx';
import React from 'react';
import { Card } from 'components/Shared/Card';
import './CICard.scss';

interface CICardProps {
    children: React.ReactNode;
    className?: string;
    elevation?: 0 | 1 | 2;
}

export const CICard: React.FC<CICardProps> = ({ children, className, ...cardProps }) => {
    return (
        <Card {...cardProps} className={clsx(className, 'TPH_CI_card')} elevation={1}>
            {children}
        </Card>
    );
};
